import { render, staticRenderFns } from "./RosaCoach.vue?vue&type=template&id=29b95ee6&"
import script from "./RosaCoach.vue?vue&type=script&lang=js&"
export * from "./RosaCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports